// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"szehIKk"};